import { ImResponse, resolve, storeHomeV2Client } from 'services/api';
import { AdminStore } from 'services/api/admin';

export function pauseTaskList() {
  return resolve(
    storeHomeV2Client.get<ImResponse<Aide.Pause.Task[]>>('/admin/list_pause_auto_reply'),
  );
}

export function pauseTask(id: string | number) {
  return resolve(
    storeHomeV2Client.get<ImResponse<Aide.Pause.Task>>('/admin/pause_auto_reply', {
      params: { id },
    }),
  );
}

export function createPauseTask(
  body: Pick<Aide.Pause.Task, 'name' | 'status' | 'platformStoreScopes'>,
) {
  return resolve(
    storeHomeV2Client.post<ImResponse<Aide.Pause.Task>>('/admin/create_pause_auto_reply', body),
  );
}

export function updatePauseTask(body: Aide.Pause.Task) {
  return storeHomeV2Client.post('/admin/update_pause_auto_reply', body);
}

export function updatePauseTaskStatus(body: Pick<Aide.Pause.Task, 'id' | 'status'>) {
  return storeHomeV2Client.post('/admin/update_pause_auto_reply_status', body);
}

export function deletePauseTask(id: string | number) {
  return storeHomeV2Client.post('/admin/del_pause_auto_reply', { id });
}

export function puaseUnusedStoreList() {
  return resolve(
    storeHomeV2Client.get<ImResponse<AdminStore[]>>('/admin/list_unallocated_store', {
      params: { scene: 'PAUSE_AUTO_REPLY' },
    }),
  );
}

export interface MoveStoresBody {
  storeIds: number[];
  scene: 'PAUSE_AUTO_REPLY';
  taskId: number;
}

export function moveStores(body: MoveStoresBody) {
  return storeHomeV2Client.post('/admin/add_store_to_task', body);
}
